// Report: clientes (persona o empresa) cuya PRIMERA reservación cayó en el
// periodo dado. Si la reservación trae empresa, la empresa es el cliente —
// no la persona que firma. Excluimos clientes con rently_reservation_count > 0
// (ya tenían historial en Rently, no son nuevos en realidad).
import supabase from "../../../supabase-client";

export const newCustomersReport = {
  id: "new-customers",
  title: "Clientes Nuevos",
  description:
    "Clientes con su primera entrega de auto en el periodo. Solo cuenta reservaciones efectivamente entregadas.",
  category: "Clientes",
  filters: [
    {
      type: "daterange",
      fromKey: "from",
      toKey: "to",
      label: "Periodo",
      required: true,
    },
  ],
  summary: [
    { type: "count", label: "Total Clientes Nuevos" },
    { type: "groupBy", label: "Por Vendedor", key: "vendor" },
    {
      type: "groupBy",
      label: "Por Tipo",
      key: "client_type",
      format: (v) => (v === "company" ? "Empresa" : v === "customer" ? "Persona" : v),
    },
  ],
  columns: [
    {
      key: "client_type",
      label: "Tipo",
      format: (v) => (v === "company" ? "Empresa" : "Persona"),
    },
    { key: "client_id", label: "ID" },
    { key: "name", label: "Nombre", width: 220, truncate: true },
    { key: "phone", label: "Teléfono" },
    { key: "email", label: "Email", width: 220, truncate: true },
    { key: "first_reservation_id", label: "Primera Reserva" },
    {
      key: "first_reservation_date",
      label: "Fecha",
      format: (v) => (v ? String(v).substring(0, 10) : ""),
    },
    { key: "vendor", label: "Vendedor" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) {
      throw new Error("Seleccionar rango de fechas");
    }
    const { data, error } = await supabase.rpc("report_new_customers", {
      p_from: from,
      p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
